import { useSelector } from 'react-redux';
import {
  Menu,
  MenuButton,
  MenuGroup,
  MenuItem,
  MenuList,
} from '@chakra-ui/react';
import { TState, useActions } from '../../redux/store';
import { CirlceIcon, allIcons } from '../utils/Icon';
import { useCanI } from '../../redux/actions';

const formatAddressLabel = (key: string) =>
  `Adresse ${key.replace(
    /^adresse|_|adresse|addressDescription/gi,
    '',
  )}`.trim();

const PlanningBtn = () => {
  const rowData = useSelector((state: TState) => state.rowData);
  const dataInputs = useSelector((state: TState) => state.dataInputs);
  const theme = useSelector((state: TState) => state.theme);
  const isMobile = useSelector((state: TState) => state.isMobile);

  const { setModalType, setPlanningAddress } = useActions();
  const canI = useCanI();
  const showBtn = canI('planning', 'create');

  const addressInputs = dataInputs.filter((i) => i.type === 'address');

  const handleClick = (name_id: string) => {
    setPlanningAddress(name_id || '');
    setModalType('addToPlanning');
  };

  return !showBtn ? null : (
    <Menu>
      <MenuButton>
        <CirlceIcon
          icon={<allIcons.HiCalendarDays size='24px' />}
          label={isMobile ? '' : 'Planifier un RDV'}
          bgColor={theme.dark}
          color={theme.none}
        />
      </MenuButton>
      <MenuList>
        {addressInputs
          ?.map((input) =>
            !rowData[`${input.name_id}_addressDescription`] ? null : (
              <MenuGroup title={formatAddressLabel(input.label || '')} my={0}>
                <MenuItem onClick={() => handleClick(input.name_id || '')}>
                  {rowData[`${input.name_id}_addressDescription`]}
                </MenuItem>
              </MenuGroup>
            ),
          )
          .filter((f) => f)}
      </MenuList>
    </Menu>
  );
};

export default PlanningBtn;
